import { CanActivateFn } from '@angular/router';
import { BbbService } from '../bbb.service';
import { inject } from '@angular/core';

export const mandantFullAccessGuard: CanActivateFn = async (route, state) => {
  const bbbService = inject(BbbService);
  const config = await bbbService.getMandantConfig()
  if (config.enableStyling == null) return true;
  return config.enableStyling;
};
